/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Welcome_BackInputs */

const cs_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vítejte zpět`)
};

const en_auth_welcome_back = /** @type {(inputs: Auth_Welcome_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back`)
};

/**
* | output |
* | --- |
* | "Welcome back" |
*
* @param {Auth_Welcome_BackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_welcome_back = /** @type {((inputs?: Auth_Welcome_BackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Welcome_BackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_welcome_back(inputs)
	return cs_auth_welcome_back(inputs)
});